module.exports = __webpack_public_path__ + "img/cm-icon.14cf15c4.png";